export default __webpack_public_path__ + "static/media/fire.e7f46cdb.webp";